<template>
  <div class="col-12">
    <table class="table table-responsive-sm table-hover">
      <thead>
      <tr>
        <th scope="col" v-t="'factor.order_item.name'"></th>
        <th scope="col" v-t="'factor.order_item.count'"></th>
        <th scope="col" v-t="'factor.order_item.price'"></th>
        <th scope="col" v-t="'factor.order_item.total'"></th>
      </tr>
      </thead>
      <tbody>
      <tr v-for="(item,index) in items" :key="index">
        <th>
          <router-link class="text-decoration-none product-name"
                       :to="{ name: 'Product', params: { name: item.product.raw_link } }">
            {{ productName(item.product,item.sub_product) }}
          </router-link>

          <div v-if="item.product.variation == 2">

            <div class="">
              <p>{{
                  dateConverter(productReservationRange(item)['min'], '/', true)
                }}</p>
              <p>{{
                  dateConverter(productReservationRange(item)['max'], '/', true)
                }}</p>
            </div>

            <div class="">
              <p v-for="(value,key) in reservationMetaTranslation(item)">{{ key }} : {{ value }}</p>
            </div>

          </div>

        </th>
        <td>{{ item.quantity }}</td>
        <td> {{ formatNumber(parseInt(item.price) - parseInt(item.offer_on_product)) }}</td>
        <td>{{ formatNumber(item.subtotal) }}</td>
      </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import {tableAttributes} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/TableAttributes";
import {dateConverter, formatNumber} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Converter";
import {
  productReservationData,
  productReservationRange,
  reservationMetaTranslation
} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/ShoppingCartFunctions";
import {productName} from "@moeinmdn/mixitweb-front-modules/src/plugin/Modules/Product";

export default {
  name: "OrderItems",
  props: ["items"],
  data() {
    return {
      tableAttributes,
      fields: [
        {key: "name", label: "نام"},
        {key: "quantity", label: "تعداد"},
        {key: "price", label: "قیمت"},
        {key: "total", label: "جمع کل"},
      ],
    };
  },
  methods: {
    productName,
    formatNumber,
    dateConverter,
    productReservationData,
    productReservationRange,
    reservationMetaTranslation,
  },
};
</script>

<style scoped>
.product-name, .product-name:hover {
  color: black;
}

</style>